import { FontColorEnum, FormField, FormHint } from '@acceso/design-system';
import { Controller, FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ScheduleItemType } from '@/types/schedules';

import { DailySchedules } from '../DailySchedules/DailySchedules';
import { ScheduleFormData } from '../DailySchedules/types';
import { EDayOfWeek } from '../Schedules/types';

type TInputSchedulesProps<T extends FieldValues> = {
  form: UseFormReturn<T>;
  name: Path<T>;
  required?: boolean;
  disabled?: boolean;
};

export function InputSchedules<T extends FieldValues>({
  form,
  name,
  required,
  disabled,
}: TInputSchedulesProps<T>) {
  const { t } = useTranslation();
  const { control } = form;

  return (
    <FormField>
      <Controller
        disabled={disabled}
        name={name}
        control={control}
        rules={{
          required: required ? { value: true, message: t('El campo es obligatorio') } : false,
        }}
        render={({ field: { value, onChange }, fieldState: { error } }) => {
          const formValue = value as ScheduleItemType[];
          const inputValue: ScheduleFormData[] = formValue.map(scheduleItem => ({
            id: scheduleItem.id,
            repetitionDayOfWeek: (scheduleItem.repetition_day_of_week
              ? scheduleItem.repetition_day_of_week.split(',')
              : []) as EDayOfWeek[],
            startHour: scheduleItem.start_hour,
            endHour: scheduleItem.end_hour,
          }));

          return (
            <>
              <DailySchedules
                value={{ schedules: inputValue }}
                onChange={data => {
                  const schedule: ScheduleItemType[] = data.schedules.map(scheduleData => ({
                    id: scheduleData.id,
                    start_hour: scheduleData.startHour,
                    end_hour: scheduleData.endHour,
                    repetition_day_of_week: scheduleData.repetitionDayOfWeek.join(','),
                  }));

                  onChange(schedule);
                }}
              />

              {error && (
                <FormHint color={FontColorEnum.Error20} type="error">
                  {error.message}
                </FormHint>
              )}
            </>
          );
        }}
      />
    </FormField>
  );
}
